// extracted by mini-css-extract-plugin
export default {"content":"j0YTI___Layout-module__content","mobileFullWidth":"eC+cl___Layout-module__mobileFullWidth"};